export default {
    name: 'InputTextArea',

    data() {
        return {
            error: '',
        }
    },

    props: {
        label: String,
        required: Boolean,
        placeholder: String,
        value: String | Number,
        disabled: Boolean,
        cols: Number,
        rows: Number,
    },

    mounted() {
    },

    methods: {
        updateValue(value) {
            this.$emit('input', value)
        },

        submit() {
            this.$refs.inputTextArea.blur()
            this.$emit('submit')
        },

        checkForError() {
            this.error = this.value || !this.required ? '' : 'input-text-area-error'
            if(this.value.length > 160){
                this.error = 'input-text-area-error'
            }
            return this.error
        }
    }
}